<template>
  <v-card width="250" class="list-card" elevation="0">
    <v-list two-lines class="py-0 list-item" :class="[onPath ? 'on-path' : '']">
      <v-tooltip top open-delay="100">
        <template v-slot:activator="{ on }">
          <v-list-item class="pl-0" v-on="on" @click="selectItem(item)">
            <v-list-item-action v-if="selectionMode" class="mx-0 list-tile-action">
              <v-checkbox v-model="item.picked" :indeterminate="item.indeterminate" color="primary" hide-details single-line @change="pickedItem(item)" />
            </v-list-item-action>
            <v-list-item-avatar v-else>
              <mf-icon v-if="item.isProduct" fill color="marca-0-l30" icon="insert_drive_file" />
              <mf-icon v-else fill color="marca-0-l10" icon="folder" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span>{{ item.name | capitalize }}</span>
              </v-list-item-title>
              <v-list-item-subtitle v-if="!item.isProduct">
                {{ $tc('produtos.arvoreProdutos.quantidadeItens', quantity(item), { quantidade: quantity(item) }) }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="!item.isProduct">
              <mf-icon>keyboard_arrow_right</mf-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
        <span class="item-name">{{ item.name | capitalize }}</span>
      </v-tooltip>
    </v-list>
  </v-card>
</template>

<script>
import capitalize from 'lodash/capitalize'
export default {
  filters: {
    capitalize(value) {
      if (value)
        return value
          .split(' ')
          .map((word) => capitalize(word))
          .join(' ')
      return ''
    },
  },
  props: {
    item: Object,
    onPath: Boolean,
    selectionMode: Boolean,
    pickedProducts: Array,
  },

  methods: {
    quantity(item) {
      if (!item.children) return 0
      return item.children.length
    },
    selectItem(item) {
      if (item.isProduct) {
        this.$router.push({ path: `/produtos/detalhes-produto/${item.id}` }).catch(() => {})
      } else if (item.children && !item.isProduct) this.$emit('selected-item', item)
    },
    pickedItem(item) {
      if (item.picked) item.indeterminate = false
      this.$emit('picked-item', item)
    },
  },
}
</script>

<style lang="scss">
.list-card {
  border-radius: 0 !important;
  .on-path {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .list-item {
    .v-list__tile {
      padding-left: 0;
    }
    .v-list__tile__avatar {
      min-width: 40px;
    }
    .v-list__tile__title {
      span {
        font-size: 12px;
      }
    }
    .v-list__tile__sub-title {
      font-size: 12px;
    }
    .v-list__tile__action {
      min-width: 24px;
    }
  }
}
.list-tile-action {
  padding-left: 8px;
}
</style>
